<template>
    <vue-recaptcha :sitekey="siteKey" @verify="handleVerification"></vue-recaptcha>
</template>
 
<script>
  import VueRecaptcha from 'vue-recaptcha';
  import {siteKey} from '../constants';

  export default {
    name: 'Recaptcha',
    components: { VueRecaptcha },
    data() {
        return {
            siteKey,
        }
    },
    methods: {
        handleVerification() {
            this.$emit('recaptchaVerified')
        },
    }
  };
</script>

<style>

</style>